module.exports = __webpack_public_path__ + "02_long_grey.87cfce2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/02_long_grey.png
// module id = rwZo
// module chunks = 0